import request from '@/request/http'
import { netUrl, dc_v2 } from '../../configapi'
import store from '@/store/index'
import axios from 'axios'

const dt = {
    // 打印设置
    printerList: data => { return request({ url: `printerList`, data, method: 'get' }) }, // 获取打印机列表
    addPrinter: data => { return request({ url: `addPrinter`, data, method: 'post' }) }, // 新增打印机
    editPrinter: data => { return request({ url: `editPrinter`, data, method: 'post' }) }, // 编辑打印机
    deletePrinter: data => { return request({ url: `deletePrinter`, data, method: 'post' }) }, // 删除打印机
    getFoodMenu: data => { return request({ url: `getFoodMenu`, data, method: 'get' }) }, // 获取菜品列表
    getPrinterInfo: data => { return request({ url: `getPrinterInfo`, data, method: 'get' }) }, // 获取单个打印机信息
    voidOrder: data => { return request({ url: `voidOrder`, data, method: 'post' }) }, // 快餐废弃订单
    getLocalIp: data => { return request({ url: netUrl + 'getLocalIp', data, method: 'get' }) },//获取本地设备IP、mac
    getPrintSet: data => { return request({ url: `getPrintSet`, data, method: 'get' }) },//获取快餐打印设置

    editShopPass : data => { return request({ url: `editShopPass` , data, method: 'post' }) },//修改店长密码
    editManagePass  : data => { return request({ url: `editManagePass` , data, method: 'post' }) },//修改管理密码

    openCasher: data => { return request({ url: netUrl + 'openCasher', data, method: 'get' }) },//打开钱箱
    getUnit: data => { return request({ url: `getUnit`, data, method: 'get' }) },//获取称重单位列表
    getFoodAmount: data => { return request({ url: `getFoodAmount`, data, method: 'get' }) }, // 获取称重金额

    getEmptyDesk: data => { return request({ url: `getEmptyDesk`, data, method: 'get' }) }, // 获取空桌分布

    orderIncome: data => { return request({ url: `orderIncome`, data, method: 'get' }) }, // 订单收款
    rechargeGiveList: data => { return request({ url: `rechargeGiveList`, data, method: 'get' }) }, // 会员充值送列表
    shopDaily: data => { return request({ url: `shopDaily`, data, method: 'get' }) }, // 日报

    uploadImage: data => { return request({ url: `uploadImage`, data, method: 'post' }) }, // 新-图片上传
    editShopConfig: data => { return request({ url: `${dc_v2}editShopConfig`, data, method: 'post' }) }, // 门店设置
    getShopInfo: data => { return request({ url: `getShopInfo`, data, method: 'get' }) }, // 获取门店设置

    finishOrder: data => { return request({ url: `finishOrder`, data, method: 'get' }) }, // 完成订单

    getShopFoodCategory: data => { return request({ url: `shopFoodCategory`, data, method: 'get' }) }, // 获取菜品分类
    priceChange: data => { return request({ url: `priceChange`, data, method: 'get' }) }, // 获取菜品价格换算关系

    setDefaultType: data => { return request({ url: `setDefaultType`, data, method: 'post' }) }, // 设置默认会员类型

    editTipStatus: data => { return request({ url: `editTipStatus`, data, method: 'post' }) }, // 更改轮播消息、打印状态
    allFoods: data => { return request({ url: `allFoods`, data, method: 'get' }) }, // 获取菜品
    // 规格
    shopSpecList: data => { return request({ url: `shopSpec/list`, data, method: 'get' }) }, // 门店规格列表
    shopSpecAdd: data => { return request({ url: `shopSpec/add`, data, method: 'post' }) }, // 添加门店规格
    shopSpecEdit: data => { return request({ url: `shopSpec/edit`, data, method: 'post' }) }, // 编辑门店规格
    shopSpecDel: data => { return request({ url: `shopSpec/del`, data, method: 'post' }) }, // 删除门店规格
    
    foodSpecList: data => { return request({ url: `foodSpec/list`, data, method: 'get' }) }, // 菜品规格列表
    foodSpecAdd: data => { return request({ url: `foodSpec/add`, data, method: 'post' }) }, // 添加菜品规格
    foodSpecEdit: data => { return request({ url: `foodSpec/edit`, data, method: 'post' }) }, // 编辑菜品规格
    foodSpecDel: data => { return request({ url: `foodSpec/del`, data, method: 'post' }) }, // 删除菜品规格
    
    preFoodAdd: data => { return request({ url: `preFood/add`, data, method: 'post' }) }, // 新增临时菜品
    
    PreOrderFoodCreate: data => { return request({ url: `PreOrderFood/create`, data, method: 'post' }) }, // 有规格的商品创建点餐订单
    PreOrderFoodCreateNew: data => { return request({ url: `PreOrderFood/createNew`, data, method: 'post' }) }, // 新有规格的商品创建点餐订单
    // 对接规格时的新接口
    shopFoodAll: data => { return request({ url: `shopFood/all`, data, method: 'get' }) }, // 通过分类ID获取该分类下菜品
    shopFoodInfo: data => { return request({ url: `shopFood/info`, data, method: 'get' }) }, // 获取菜品详情
    shopFoodUpdate: data => { return request({ url: `shopFood/update`, data, method: 'post' }) }, // 更新菜品
    PreOrderFoodRead: data => { return request({ url: `PreOrderFood/read`, data, method: 'get' }) }, // 获取点餐购物车菜品
    shopFoodChangeStatus: data => { return request({ url: `shopFood/changeStatus`, data, method: 'post' }) }, // 更新菜品售罄状态
    // 小程序扫码点餐
    confirmMiniOrder: data => { return request({ url: `confirmMiniOrder`, data, method: 'post' }) }, // 小程序扫码点单确认订单
    // cancelMiniOrder: data => { return request({ url: `cancelMiniOrder`, data, method: 'post' }) }, // 小程序扫码点单取消订单
    // 经营模式
    getBusinessModel: data => { return request({ url: `${dc_v2}getBusinessModel`, data, method: 'get' }) }, // 获取经营模式配置
    // 修改经验模式
    editBusinessModel: data => { return request({ url: `${dc_v2}editBusinessModel`, data, method: 'post' }) }, // 修改经营配置信息

    // 大趋云打印机
    daqPrint_dqPrint: data => { return request({ url: `daqPrint/dq-print`, data, method: 'post' }) }, // 大趋小票云打印接口
    daqPrint_dqQr: data => { return request({ url: `daqPrint/dq-qr`, data, method: 'post' }) }, // 大趋小票云打印二维码接口
    daqPrint_dqPrintStatus: data => { return request({ url: `daqPrint/dq-printStatus`, data, method: 'get' }) }, // 大趋查询云打印小票打印机状态
    daqPrint_printDeposit: data => { return request({ url: `daqPrint/printDeposit`, data, method: 'post' }) }, // 大趋寄存小票打印

    clearTableList: data => { return request({ url: `Desk/clearNewTableList`, data, method: 'get' }) }, // 获取新清台列表
    clearTableAll: data => { return request({ url: `Desk/clearTableAll`, data, method: 'get' }) }, // 获取新清台列表

    // 菜品图片扫码上传
    addFoodImage: data => { return request({ url: `shopFood/addFoodImage`, data, method: 'post' }) }, // 扫描二维码上传图片接口

    // 换台
    doChangeDesk: data => { return request({ url: `ChangeDesk/doChangeDesk`, data, method: 'post' }) }, // 换台接口

    // 开台清台处理
    ShopDesksClearTable: data => { return request({ url: `ShopDesks/clearTable`, data, method: 'post' }) }, // 新清台接口
    ShopDesksNewClearTable: data => { return request({ url: `ShopDesks/newClearTable`, data, method: 'post' }) }, // 新清台接口
    ShopDesksOpenDesk: data => { return request({ url: `ShopDesks/openDesk`, data, method: 'post' }) }, // 新开台接口
    ShopDesksDeskList: data => { return request({ url: `ShopDesks/deskList`, data, method: 'get' }) }, // 新获取桌台列表接口
    cancelMiniDeskOrder: data => { return request({ url: `cancelMiniDeskOrder`, data, method: 'post' }) }, // 新小程序扫码点单取消订单


    addTestPrintLog: data => { return request({ url: `Test/addTestPrintLog`, data, method: 'post' }) }, // 添加测试打印日志
    addFoodPrintLog: data => { return request({ url: `ShopFood/addFoodPrintLog`, data, method: 'post' }) }, // 添加菜品打印日志
    getFoodPrintLog: data => { return request({ url: `ShopFood/getFoodPrintLog`, data, method: 'get' }) }, // 获取菜品打印失败日志
    setFoodPrintLog: data => { return request({ url: `ShopFood/setFoodPrintLog`, data, method: 'post' }) }, // 更新菜品打印失败日志

    // 小程序扫码点餐先付后吃
    finishMiniOrder: data => { return request({ url: `Order/finishMiniOrder`, data, method: 'post' }) }, // 结账接口
    returnPayOrderFood: data => { return request({ url: `ReturnOrderFood/returnPayOrderFood`, data, method: 'post' }) }, // 退菜接口

    checkShopLevel: data => { return request({ url: 'Test/checkShopLevel', data, method: 'post' }) }, // 检测门店类型

    updateFoodNums: data => { return request({ url: `PreOrderFood/updateFoodNums`, data, method: 'post' }) }, // 更新购物车菜品数量

    text2video: data => { return request({ url: `baidu/text2video`, data, method: 'post' }) }, // 语音播报

    // 门店设置-开台必点
    getOpenMustSet: data => { return request({ url: `Shop/getOpenMustSet`, data, method: 'get' }) }, // 获取开台必点设置
    updateOpenMustSet: data => { return request({ url: `Shop/updateOpenMustSet`, data, method: 'post' }) }, // 编辑开台必点设置
    getOrderTransSet: data => { return request({ url: `Shop/getOrderTransSet`, data, method: 'get' }) }, // 获取订单流转配置
    editOrderTransSet: data => { return request({ url: `Shop/editOrderTransSet`, data, method: 'post' }) }, // 编辑订单流转配置
    getFoodList: data => { return request({ url: `ShopFood/getFoodList`, data, method: 'get' }) }, // 获取菜品列表
    getMustFoodInfo: data => { return request({ url: `PreOrderFood/getMustFoodInfo`, data, method: 'get' }) }, // 获取必点菜品
    getVoiceSet: data => { return request({ url: `Shop/getVoiceSet`, data, method: 'get' }) }, // 获取语音设置
    editVoiceSet: data => { return request({ url: `Shop/editVoiceSet`, data, method: 'post' }) }, // 设置语音播报设置

    delMember: data => { return request({ url: `delMember`, data, method: 'post' }) }, // 删除会员

    confirmRefundOrder: data => { return request({ url: `OrderRefund/confirmRefundOrder`, data, method: 'post' }) }, // 先付后吃退菜退款失败-点击确认（线下退款）
    
    upgradeRemind: data => { return request({ url: `Shop/upgradeRemind`, data, method: 'get' }) }, // 获取系统提示
    getRechargeRecord: data => { return request({ url: `Report/getRechargeRecord`, data, method: 'get' }) }, // 报表-充值明细

    checkOrderStatus: data => { return request({ url: `Order/checkOrderStatus`, data, method: 'post' }) }, // 检测目前订单操作状态
    
    getOrderSummary: (data, that) => { return request({ url: `Order/getOrderSummary`, data, method: 'get', 
        cancelToken: new axios.CancelToken(function executor(c) { // 设置 cancel token
            that.source = c;
        })
    }) }, // 新订单汇总接口
    getCheckOrderInfo: data => { return request({ url: `Order/getCheckOrderInfo`, data, method: 'get' }) }, // 新订单结账页面接口
    scanSpay: data => { return request({ url: `PlaceOrder/scanSpay`, data, method: 'post' }) }, // 新订单扫码支付接口

    // 套餐
    ShopFoodNewAll: data => { return request({ url: `shopFood/newAll`, data, method: 'get' }) }, // 获取菜品

    // 库存
    getStockLog: data => { return request({ url: `ShopFoodStock/getStockLog`, data, method: 'get' }) }, // 库存变动记录
    getStockList: data => { return request({ url: `ShopFoodStock/getStockList`, data, method: 'get' }) }, // 库存管理列表
    updateStock: data => { return request({ url: `ShopFoodStock/updateStock`, data, method: 'post' }) }, // 库存管理-调整库存

    // 流水号规则设置
    sweepMealNew: data => { return request({ url: `sweepMealNew`, data, method: 'get' }) }, // 新点餐获取订单编号、流水号
    getFlowingWater: data => { return request({ url: `Shop/getFlowingWater`, data, method: 'get' }) }, // 获取流水号设置
    setFlowingWater: data => { return request({ url: `Shop/setFlowingWater`, data, method: 'post' }) }, // 保存流水号设置

    setFoodUnit: data => { return request({ url: `Shop/setFoodUnit`, data, method: 'post' }) }, // 添加单位

    jiabo_print: data => { return request({ url: `JiabPrint/jb-print`, data, method: 'post' }) }, // 佳博打印小票
    jiabo_tagPrint: data => { return request({ url: `JiabPrint/jb-tagPrint`, data, method: 'post' }) }, // 佳博打印小票
    jiabo_printDeposit: data => { return request({ url: `JiabPrint/printDeposit`, data, method: 'post' }) }, // 佳博寄存小票打印

    getMobileCheckLog: data => { return request({ url: `Shop/getMobileCheckLog`, data, method: 'get' }) }, // 手机号验证记录

    AddDeposit: data => { return request({ url: `deposit/deposit`, data, method: 'post' }) }, // 添加寄存
    getDepositList: (data, that) => { return request({ url: `deposit/deposit`, data, method: 'get',
        cancelToken: new axios.CancelToken(function executor(c) {
            that.source = c;
        })
    }) }, // 寄存列表
    getDepositDetail: (id, data, that) => { return request({ url: `deposit/deposit/${id}`, data, method: 'get',
        cancelToken: new axios.CancelToken(function executor(c) {
            that.source = c;
        })
    }) }, // 寄存详情
    getRecaptionLog: data => { return request({ url: `deposit/getUserList`, data, method: 'get' }) }, // 取回明细
    UserTask: data => { return request({ url: `deposit/UserTask`, data, method: 'post' }) }, // 取回
    depositDataTable: data => { return request({ url: `deposit/stat`, data, method: 'get' }) }, // 寄存统计

    shopFoodSync: data => { return request({ url: `ShopFood/shopFoodSync`, data, method: 'post' }) }, // 同步套餐菜品

    // 授权购买
    getAuthPriceList: data => { return request({ url: `${dc_v2}GeneralPayment/getAuthPriceList`, data, method: 'get' }) }, // 获取授权价格列表
    generatePayQrcode: data => {
        const form = new URLSearchParams();
        Object.keys(data).forEach(key => form.append(key, data[key]));
        return request({ url: `${dc_v2}GeneralPayment/generatePayQrcode`, data: form, method: 'post' });
    },
    queryPayStatus: data => { return request({ url: `${dc_v2}GeneralPayment/queryPayStatus`, data, method: 'get' }) }, // 查询支付状态

    getNewStaffRemain: data => { return request({ url: `getNewStaffRemain`, data, method: 'get' }) }, // 查询新服务员剩余数量
    getCashierRemain: data => { return request({ url: `getCashierRemain`, data, method: 'get' }) }, // 查询收银员剩余数量

    // 新增：删除订单（后端接口 deleteOrderAction）
    deleteOrderAction: data => { return request({ url: `deleteOrderAction`, data, method: 'post' }) }, // 删除订单

    // 注销账号
    cancelAccount: data => {
        const form = new URLSearchParams();
        Object.keys(data).forEach(key => form.append(key, data[key]));
        return request({ url: `${dc_v2}Login/cancelAccount`, data: form, method: 'post' });
    }, // 注销账号
}

export default dt



// WEBPACK FOOTER //
// ./src/request/dt.js